import React from "react";

export const PenIcon = ({
  width = "18.941",
  height = "18.941",
  fill = "#89ab0d",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.941 18.941"
      {...{ width, height, fill }}
    >
      <path
        id="iconmonstr-pencil-thin"
        d="M6.785,17.843,1,19l1.157-5.785L14.372,1,19,5.628Zm-.4-.754L2.91,13.618l-.867,4.339Zm7.99-14.933L3.49,13.04,6.96,16.51,17.843,5.628,14.372,2.157Z"
        transform="translate(-0.554 -0.505)"
        stroke="#89ab0d"
        strokeWidth="0.7"
        fillRule="evenodd"
      />
    </svg>
  );
};
